import type { PropsWithChildren, ReactElement } from 'react';
import { ModalBackground } from './ModalBackground';
import { ModalWindow } from './ModalWindow';

type ModalProps = PropsWithChildren<{
  onClose: () => void;
  windowClassName?: string;
}>;

export default function Modal(props: ModalProps): ReactElement {
  return (
    <ModalBackground onClose={props.onClose}>
      <ModalWindow onClose={props.onClose} className={props.windowClassName}>
        {props.children}
      </ModalWindow>
    </ModalBackground>
  );
}
